import { useEffect, useState } from "react"
import { FaInstagram } from "react-icons/fa"
import { useParams } from "react-router-dom"

export default function ProfileCard(){

  const { slug } = useParams()
  const [data,setData] = useState(null)

  useEffect(()=>{

    fetch(`${process.env.REACT_APP_BASE_URL}api/teams/profile/${slug}`)
    
    .then(res=>res.json())
    .then(res=>setData(res))

  },[slug])


  if(!data){
    return(
      <div className="min-h-screen flex items-center justify-center text-white">
        Loading...
      </div>
    )
  }

  return(

    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#3E3274] via-red-700 to-[#3E3274] animate-gradient p-6">
      <div className="w-full max-w-[380px]">
        {/* CARD */}
        <div className="relative rounded-[28px] bg-white/15 backdrop-blur-2xl border border-white/20 shadow-[0_25px_60px_rgba(0,0,0,0.45)] overflow-hidden">
          {/* TOP HEADER */}
          <div className="p-6 flex items-center justify-between">
            <img src="/images/logo.png" className="h-8 opacity-90"/>
            <img src="/images/pjt-white.png" className="h-8 opacity-90"/>
          </div>
          {/* PHOTO */}
          <div className="flex justify-center mt-2">
            <img
              src={`${process.env.REACT_APP_BASE_URL}uploads/images/${data.photo}`}
              className="w-[140px] h-[140px] rounded-full object-cover border-4 border-white/40 shadow-xl"
            />
          </div>
          {/* NAME */}
          <div className="text-center mt-4 px-6">
            <h1 className="font-bricolage text-white text-2xl font-semibold tracking-wide">
              {data.name}
            </h1>
            <p className="text-white/70 text-sm mt-1">
              {data.position}
            </p>
          </div>
          {/* DIVIDER */}
          <div className="my-5 border-t border-white/20"></div>
          {/* INFO */}
          <div className="px-8 pb-8 space-y-3 text-sm text-white/90">
            <div className="flex justify-between">
              <span className="text-white/60">Division</span>
              <span>{data.division}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-white/60">NIK</span>
              <span>{data.nik}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-white/60">TTL</span>
              <span className="text-right">{data.ttl}</span>
            </div>
          </div>
          {/* QUOTES */}
          {data.quotes && (
            <div className="px-8 pb-8">
              <p className="text-center text-white/80 text-sm italic before:content-['“'] after:content-['”']">
                {data.quotes}
              </p>
            </div>
          )}
          {/* INSTAGRAM */}
          {data.ig && (
            <div className="flex pb-8 justify-center">
              <a
                href={`https://instagram.com/${data.ig}`}
                target="_blank"
                className=""
              >
                <div className="px-6 flex items-center text-white gap-2 flex-row py-4 bg-gradient-to-r from-red-600  to-[#3E3274] rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300 cursor-pointer">
                    <FaInstagram size={21}></FaInstagram> {data.ig}
                </div>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}